import * as React from 'react';

import { useChat } from '@ai-sdk/react';

import { Text } from '@components/common';
import { useAiApiHost } from '@components/StudioApp/hooks/useAiApiHost';
import { useAutoScroll } from '@components/utils/hooks';
import { useFeature } from '@hooks/useFeature';

import { ChatInput, MessagesList } from './components';

export const ChatPrototypeApp: React.FC<React.PropsWithChildren<unknown>> = () => {
  const chatPrototypeEnabled = useFeature('chat_prototype');
  const aiApiHost = useAiApiHost();
  const { messages, input, handleInputChange, handleSubmit } = useChat({
    api: `${aiApiHost}/api/ai/v1/chat`,
    credentials: 'include',
    streamProtocol: 'data'
  });
  const messagesEndRef = useAutoScroll(messages);

  if (!chatPrototypeEnabled) {
    return null;
  }

  return (
    <div className='h-screen bg-gray-50 p-6'>
      <div className='mx-auto h-full max-w-5xl'>
        <div className='flex h-full flex-col rounded-lg border border-gray-200 bg-white'>
          <div className='flex-shrink-0 border-b border-gray-200 bg-white px-6 py-4'>
            <Text h='600' bold>
              Chat Prototype
            </Text>
          </div>
          <MessagesList messages={messages} messagesEndRef={messagesEndRef} />
          <ChatInput inputValue={input} onInputChange={handleInputChange} onSendMessage={handleSubmit} />
        </div>
      </div>
    </div>
  );
};
